<div class="trivia-host-container">
  <div class="page-container">
    <div *ngIf="!currentQuestion && gameResults.length === 0">
      <h1>Welcome to the Tele-Sketchpad Game!</h1>

      <h2>To Join the game, please connect using this room code: <strong>{{ gameId }}</strong></h2>

      <h2>Players go to <a href="//alpha.tableflip.games/login" target="_blank"><strong>BIT.LY/TBLFLP</strong></a> on your favorite browser to join in on the fun!</h2>
    </div>

    <h1 class="game-over" *ngIf="gameOverMessage !== ''">{{ gameOverMessage }}</h1>

    <div class="question-container" *ngIf="currentQuestion">
      <h1>{{ currentQuestion.question }}</h1>
      <ul>
        <li *ngFor="let choice of currentQuestion.choices">
          {{ choice }}
        </li>
      </ul>
    </div>

    <div class="end-game-presentation-container" *ngIf="gameResults.length > 0">
      <div class="game-over-btn-container">
        <button mat-raised-button color="primary" class="full-width" (click)="playAgain()">Play Again</button>
        <button mat-raised-button color="secondary" class="full-width" (click)="playAgain(false)">Choose Another Game</button>
      </div>

      <div>
        <ul>
          <li *ngFor="let card of gameResults">
            <h1>{{ card.name }}'s original word was: {{ card.originalWord }}</h1>
            <div class="drawing-container" *ngIf="card.isDrawing">
              <p>Artist: {{ card.artist }}</p>
              <img [src]="card.content">
            </div>
            <div class="guess-container" *ngIf="!card.isDrawing">
              <p>{{ card.artist }} guessed:</p>
              <h2>{{ card.content }}</h2>
            </div>
          </li>
        </ul>
      </div>
    </div>

    <div class="connected-users" *ngIf="connectedUsers.length > 0 && gameResults.length < 1">
      <div class="user-list-container">
        <ul class="user-list">
          <li *ngFor="let connectedUser of connectedUsers">
            <img class="avatar" src="{{ connectedUser.avatar }}">
            <p class="username"><strong>{{ connectedUser.name }}</strong></p>
            <p class="score" [style.height]="(connectedUser.currentScore / 2) + 'vh'"><strong>{{ connectedUser.currentScore }}</strong></p>
          </li>
        </ul>
      </div>
    </div>
  </div>
</div>
